<template>
  <v-row no-gutters>
    <v-tooltip bottom v-if="tooltip">
      <template v-slot:activator="{ on, attrs }">
        <v-textarea
            v-bind="$attrs"
            :value="value"
            :outlined="outlined"
            dense
            :clearable="clearable"
            @input="$emit('input', $event !== '' ? $event : null)"
            :no-resize="noResize"
            v-on="on"
            hide-details
        >
        </v-textarea>
      </template>
      <span>{{ value }}</span>
    </v-tooltip>
    <v-textarea
        v-if="!tooltip"
        v-bind="$attrs"
        :value="value"
        :outlined="outlined"
        dense
        :clearable="clearable"
        @input="$emit('input', $event !== '' ? $event : null)"
        :no-resize="noResize"
        hide-details
    >
    </v-textarea>
  </v-row>
</template>

<script>

export default {
  name: 'CommonFieldText',
  inheritAttrs: false,
  props: {
    value: {},
    clearable: {default: false},
    outlined: {default: true},
    noResize: {default: true},
    tooltip: {default: false},
  },

  components: {},

  computed: {},

  methods: {},

  async mounted() {
  },

  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>
